import { useState } from "react"

export const useForm = ( initialState = {} ) => {
    const [values, setValues] = useState(initialState)

    const reset = ()=> {
        setValues( initialState );
    };
    const handelInputChange = (e) => {
        if(e.target.type === 'checkbox'){
            setValues({
                ...values,
                [e.target.name]: !values[e.target.name]
            })
        }else{
            setValues({
                ...values,
                [e.target.name]: e.target.value
            })
        }
    }

    return [ values, handelInputChange, reset ]
}
